<div>
    <div class="login-page-title">{{localizationKeys.aumico_reports_login_title | i18next}}</div>
    <div class="login-page-shortIntroduction">{{'aumico_reports_login_introduction' | i18next }}</div>
</div>
<div>
    <form class="login-form" [formGroup]="loginForm">
        <div class="form-group">
            <div class="input-wrapper">
                <input
                    label="{{'aumico_reports_reset_password_forgot_email_username'| i18next}}"
                    hamInput
                    id="userName"
                    class="form-control"
                    type="text"
                    formControlName="userName"
                    [placeholder]="localizationKeys.aumico_reports_input_please_enter_placeholder
          |
          i18next"
                />
            </div>
        </div>
        <div class="form-group">
            <div class="input-wrapper">
                <input
                    hamInput
                    label="{{localizationKeys.aumico_reports_password | i18next}}"
                    id="password"
                    class="form-control"
                    type="password"
                    formControlName="password"
                    [placeholder]="localizationKeys.aumico_reports_input_please_enter_placeholder
          |
          i18next"
                />
            </div>
        </div>
        <div class="errorMessages">
            <span class="unauthorized" *ngIf="isLoginFailed">{{errorMessage | i18next}}</span>
        </div>

        <div class="login-action-buttons">
            <ham-button id="loginButton" [disabled]="loginForm.invalid" (buttonClick)="onLoginUser()" type="submit">
                {{localizationKeys.aumico_reports_login_login_button | i18next}}
            </ham-button>
            <ham-button [routerLink]="['../reset/']" variant="white">
                {{localizationKeys.aumico_reports_login_forgot_password | i18next}}
            </ham-button>
        </div>
    </form>
</div>
<app-component-random-questions-with-action-button [question]="actionButtonQuestion" [actionButton]="actionButton">
</app-component-random-questions-with-action-button>
